import { createContext } from 'react';

type NotificationType = 'success' | 'error' | 'warning' | 'info';

interface ToastContextType {
  showToast: (toast: {
    type: NotificationType;
    title?: string;
    message: string;
    duration?: number;
  }) => void;
  hideToast: (id: string) => void;
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined);
